import * as React from "react";
import {
  StyledMainCard,
  StyledSupportCard,
  NameTag,
  NightCount,
  StatusTag,
} from "./styles";
import assets from "../../assets/";

export interface CardProps {
  variant: "main" | "support";
  unitName?: string;
  numNights?: string | number;
  numAdults?: string;
  numChildren?: string;
  onClick: () => void;
  imageSrc?: string;
  fullWidth?: boolean;
  status?: string;
}

export const Card = ({
  unitName,
  onClick,
  numNights,
  variant,
  imageSrc,
  fullWidth,
  numAdults,
  numChildren,
  status,
}: CardProps) => {
  if (variant === "main") {
    return (
      <StyledMainCard fullWidth={fullWidth} onClick={onClick}>
        <img
          src={imageSrc ? imageSrc : assets.CityVector}
          alt={`${unitName} gallery`}
        />
        <StatusTag>{status}</StatusTag>
        <NameTag fullWidth={fullWidth}>{unitName}</NameTag>
        <NightCount fullWidth={fullWidth}>
          <span>
            🌙
            <p>
              {numNights} {numNights === 1 ? "Night" : "Nights"}
            </p>
          </span>
          {numAdults && (
            <span>
              👨🏻👩🏻{" "}
              <p>
                {numAdults} {numAdults === "1" ? "Adult" : "Adults"}
              </p>
            </span>
          )}
          {numChildren && numChildren !== "0" && (
            <span>
              👦🏻👧🏻{" "}
              <p>
                {numChildren} {numChildren === "1" ? "Child" : "Children"}
              </p>
            </span>
          )}
        </NightCount>
      </StyledMainCard>
    );
  } else {
    return (
      <StyledSupportCard onClick={onClick} fullWidth={fullWidth}>
        <img src={imageSrc} alt={`${unitName} gallery`} />
        <h4>{unitName}</h4>
        <p>{numNights} Nights</p>
      </StyledSupportCard>
    );
  }
};
